import React, {useEffect, useState,} from "react";
import {Select as AntSelect} from "antd";
import {DefaultOptionType, SelectProps} from "antd/lib/select";
import request from "../../utils/request";


interface MySelectProps extends SelectProps {
    url: string
    textField?: string
    valueField?: string
    getData?: (data: any) => any
    setDefault?: (data: any) => any
    onChangeWithOption?: (v: any, o: DefaultOptionType|DefaultOptionType[]) => void
}

function Select(props: MySelectProps) {

    const [data, setData] = useState([])
    const {
        url,
        textField = 'text',
        valueField = 'id',
        getData,
        onChange,
        onChangeWithOption,
        setDefault,
        ...otherProps
    } = props

    useEffect(() => {
        request.get(url).then(response => {
            let data = response.data
            if (getData) {
                data = getData(data)
            }
            setData(data)
            if (setDefault && onChange) {
                const item = setDefault(data)
                item && onChange(item, {} as any)
            }
        })
    }, [url]);

    const dualOnChange = (v: any, o: DefaultOptionType|DefaultOptionType[]) => {
        if (onChange) {
            onChange(v, o);
        }
        if (onChangeWithOption) {
            const option:any = data.find((i: any) => i[valueField] == v) ?? {};
            onChangeWithOption(v,option);
        }
    }

    return (
        <AntSelect showSearch optionFilterProp={'children'} onChange={dualOnChange} {...otherProps}>
            {data.map(item => (
                <AntSelect.Option key={item[valueField]} value={item[valueField]}>
                    {item[textField]}
                </AntSelect.Option>
            ))}
        </AntSelect>
    )
}

export default Select
